export const GET_APPOINTMENT_SEARCH = "GET_APPOINTMENT_SEARCH"
export const GET_APPOINTMENT_SEARCH_FAIL = "GET_APPOINTMENT_SEARCH_FAIL"
export const GET_APPOINTMENT_SEARCH_SUCCESS = "GET_APPOINTMENT_SEARCH_SUCCESS"
export const GET_APPOINTMENT_SEARCH_RESET = "GET_APPOINTMENT_SEARCH_RESET"

export const getAppointmentSearch = (params) => {
    return { type: GET_APPOINTMENT_SEARCH, params }
}
export const getAppointmentSearchFail = (response) => {
    return { type: GET_APPOINTMENT_SEARCH_FAIL, response }
}
export const getAppointmentSearchSuccess = (response) => {
    return { type: GET_APPOINTMENT_SEARCH_SUCCESS, response }
}
export const getAppointmentSearchReset = () => {
    return { type: GET_APPOINTMENT_SEARCH_RESET }
}